import httpUserClient from '@/plugins/httpUserClient';

export default {
  index(fundId, currentPage, perPage) {
    return httpUserClient.get(`expense/user/fund_items/${fundId}/receipts?page=${currentPage}&per_page=${perPage}`);
  },
  show(id) {
    return httpUserClient.get(`expense/user/receipts/${id}`);
  },
  create(fundId, data) {
    return httpUserClient.post(`expense/user/fund_items/${fundId}/receipts`, { expense_receipt: { ...data } });
  },
  patch(id, data) {
    return httpUserClient.patch(`expense/user/receipts/${id}`, { expense_receipt: { ...data } });
  },
  update(id, data) {
    return httpUserClient.patch(`expense/user/receipts/${id}`, { expense_receipt: { ...data } });
  },
  delete(id) {
    return httpUserClient.delete(`expense/user/receipts/${id}`);
  },
  // 所有的报销
  list(currentPage, perPage) {
    return httpUserClient.get(`expense/user/receipts?page=${currentPage}&per_page=${perPage}`);
  },
  // 某次申报的报销
  projectList(projectId, currentPage, perPage) {
    return httpUserClient.get(`expense/user/research_projects/${projectId}/receipts?page=${currentPage}&per_page=${perPage}`);
  },
  // 审批日志
  logs(receiptId, currentPage, perPage) {
    return httpUserClient.get(`expense/user/receipts/${receiptId}/logs?page=${currentPage}&per_page=${perPage}`);
  },
  log(receiptId, id) {
    return httpUserClient.get(`expense/user/receipts/${receiptId}/logs/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/research/api-receipt.js